import { render, staticRenderFns } from "./ViewPost.vue?vue&type=template&id=6491e63d&"
import script from "./ViewPost.vue?vue&type=script&lang=js&"
export * from "./ViewPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports